import React, { Component } from 'react';
import './Events.css';
import Modal from '../components/Modal/Modal';
import Backdrop from '../components/Backdrop/Backdrop';
import AuthContext from '../context/auth-context';
import EventList from '../components/Events/EventList/EventList';
import Spinner from '../components/Spinner/Spinner';

export default class EventsPage extends Component {

    state = {
        creating: false,
        events: [],
        isLoading: false,
        selectedEvent: null
    }

    isActive = true;

    static contextType = AuthContext;

    constructor(props) {
        super(props);
        this.titleElRef = React.createRef();
        this.priceElRef = React.createRef();
        this.dateElRef = React.createRef();
        this.descriptionElRef = React.createRef();
    }

    componentDidMount() {
        this.fetchEvents();
    }

    startCreateEventHandler = () => {
        this.setState({ creating: true })
    }

    fetchRequest = (requestBody) => {
        return fetch('https://favorite-events-api.herokuapp.com/graphql', {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + this.context.token
            }
        }).then(res => {
            if (res.status !== 200 && res.status !== 201) {
                throw new Error('Failed!');
            }
            return res.json();
        })
    }

    modalConfirmHandler = () => {
        this.setState({ creating: false });
        const title = this.titleElRef.current.value;
        const price = +this.priceElRef.current.value;
        const date = this.dateElRef.current.value;
        const description = this.descriptionElRef.current.value;

        if (
            title.trim().length === 0 ||
            price <= 0 ||
            date.trim().length === 0 ||
            description.trim().length === 0
        ) {
            return;
        }

        const requestBody = {
            query: `
                    mutation CreateEvent($title: String!, $desc: String!, $price: Float!, $date: String!) {
                        createEvent(eventInput: {title: $title, description: $desc, price: $price, date: $date}) {
                            _id
                            title
                            description
                            price
                            date
                            creator {
                                _id
                                email
                            }
                        }
                    }
                `,
            variables: {
                title: title,
                desc: description,
                price: price,
                date: date
            }
        }

        this.fetchRequest(requestBody).then(resData => {
            this.setState(prevState => {
                const updateEvents = [...prevState.events];
                updateEvents.push({
                    _id: resData.data.createEvent._id,
                    title: resData.data.createEvent.title,
                    description: resData.data.createEvent.description,
                    date: resData.data.createEvent.date,
                    price: resData.data.createEvent.price,
                    creator: {
                        _id: this.context.userId
                    }
                });
                return { events: updateEvents };
            })
        }).catch(err => {
            console.log(err);
        });
    }

    modalCancelHandler = () => {
        this.setState({ creating: false, selectedEvent: null });
    }

    fetchEvents() {
        this.setState({ isLoading: true })
        const requestBody = {
            query: `
                    query {
                        events {
                            _id
                            title
                            description
                            price
                            date
                            creator {
                                _id
                                email
                            }
                        }
                    }
                `
        }

        this.fetchRequest(requestBody).then(resData => {
            const events = resData.data.events;
            if (this.isActive) {
                this.setState({ events: events, isLoading: false });
            }
        }).catch(err => {
            console.log(err);
            if (this.isActive) {
                this.setState({ isLoading: false });
            }
        });
    }

    showDetailHandler = eventId => {
        this.setState(prevState => {
            const selectedEvent = prevState.events.find(e => e._id === eventId);
            return { selectedEvent: selectedEvent };
        })
    }

    bookEventHandler = () => {
        if (!this.context.token) {
            this.setState({ selectedEvent: null });
            return;
        }

        const requestBody = {
            query: `
                    mutation BookEvent($id: ID!) {
                        bookEvent(eventId: $id) {
                            _id
                            createdAt
                            updatedAt
                        }
                    }
                `,
            variables: {
                id: this.state.selectedEvent._id
            }
        }

        this.fetchRequest(requestBody).then(resData => {
            this.setState({ selectedEvent: null });
        }).catch(err => {
            console.log(err);
        });
    }

    componentWillUnmount() {
        this.isActive = false;
    }

    render() {
        return (
            <React.Fragment>
                {(this.state.creating || this.state.selectedEvent) && <Backdrop />}
                {this.state.creating &&
                    <Modal
                        title="Add Event"
                        canCancel
                        canConfirm
                        onCancel={this.modalCancelHandler}
                        onConfirm={this.modalConfirmHandler}
                        confirmText="Save"
                    >
                        <form>
                            <div className="form-control">
                                <label htmlFor="title">Title</label>
                                <input type="text" id="title" ref={this.titleElRef} />
                            </div>
                            <div className="form-control">
                                <label htmlFor="price">Price</label>
                                <input type="number" id="price" ref={this.priceElRef} />
                            </div>
                            <div className="form-control">
                                <label htmlFor="date">Date</label>
                                <input type="datetime-local" id="date" ref={this.dateElRef} />
                            </div>
                            <div className="form-control">
                                <label htmlFor="description">Description</label>
                                <textarea id="description" rows="3" ref={this.descriptionElRef} />
                            </div>
                        </form>
                    </Modal>}
                {this.state.selectedEvent &&
                    <Modal
                        title={this.state.selectedEvent.title}
                        canCancel
                        canConfirm
                        onCancel={this.modalCancelHandler}
                        onConfirm={this.bookEventHandler}
                        confirmText={this.context.token ? 'Book' : 'Accept'}
                    >
                        <h1>{this.state.selectedEvent.title}</h1>
                        <h2>$ {this.state.selectedEvent.price}</h2>
                        <strong>Date: </strong><span>{new Date(this.state.selectedEvent.date).toLocaleDateString()}</span><br /><br />
                        <strong>Description: </strong><p>{this.state.selectedEvent.description}</p>
                    </Modal>
                }
                {this.context.token && (
                    <div className="events-control">
                        <p>Share your own Favorite Events!</p>
                        <button className="btn" onClick={this.startCreateEventHandler}>Create Event</button>
                    </div>
                )}
                {this.state.isLoading ? (
                    <Spinner />
                ) : (
                        <EventList
                            events={this.state.events}
                            authUserId={this.context.userId}
                            onViewDetails={this.showDetailHandler}
                        />
                    )}
            </React.Fragment>
        )
    }
}
